import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$location', '$window',
  function GoogleShare ($location, $window) {
    return {
      restrict: 'C',
      replace: true,
      templateUrl: cdnTemplate('/social-share-button.html'),
      scope: true,
      link: (scope) => {
        scope.share = function GoogleShareCall () {
          $window.open(`https://plus.google.com/share?url=${encodeURIComponent($location.absUrl())}`, 'google+', 'width=600,height=530');
        };
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/social-share/google.dir.js